import { reduxEffectTypes } from 'src/types';
import { EFFECT_ADDED, EFFECT_DELETED, EFFECT_EDITED, EFFECT_SET } from '../redux-types';

export const effectDefaultState: reduxEffectTypes.StateType = {
  effectList: [],
};

export const effectReducer = (
  state = effectDefaultState,
  action: reduxEffectTypes.ActionType,
): reduxEffectTypes.StateType => {
  switch (action.type) {
    case EFFECT_SET:
      return {
        ...state,
        effectList: action.payload,
      };
    case EFFECT_ADDED:
      const exists = state.effectList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        effectList: [...state.effectList, action.payload],
      };
    case EFFECT_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.effectList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        effectList: [
          ...state.effectList.slice(0, updateIndex),
          action.payload,
          ...state.effectList.slice(updateIndex + 1),
        ],
      };
    case EFFECT_DELETED:
      return {
        ...state,
        effectList: state.effectList.filter((o) => o.id !== action.payload),
      };

    default:
      return state;
  }
};
